import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { updateCoveredAreas } from "../../api/engineerApi";
import { toast } from "react-toastify";

// eslint-disable-next-line no-unused-vars
const AreaCovered = ({ userProfile, regions, areas, profileAuth, loadProfile }) => {
  const [myAreasCovered, setMyAreasCovered] = useState(userProfile.coverage_areas);
  const [formChanged, setFormChanged] = useState(false);

  useEffect(() => {
    const myNewAreas = userProfile.coverage_areas;
    setMyAreasCovered(myNewAreas);
  }, [userProfile.coverage_areas]);

  const checkIfCovered = (areaCode) => {
    let returnValue = false;

    myAreasCovered.forEach((area) => {
      if (area.areaCode === areaCode) {
        returnValue = true;
      }
    });

    return returnValue;
  };

  useEffect(() => {
    if (formChanged) {
      window.addEventListener("beforeunload", alertUser);
      return () => {
        window.removeEventListener("beforeunload", alertUser);
      };
    } else {
      window.removeEventListener("beforeunload", alertUser);
    }
  }, [formChanged]);

  const alertUser = (e) => {
    e.preventDefault();
    e.returnValue = "";
  };

  const onAreaClick = (areaId) => {
    setFormChanged(true);

    const isCovered = checkIfCovered(areas.find((a) => a.id === areaId)?.areaCode);

    if (isCovered) {
      setMyAreasCovered(myAreasCovered.filter((area) => area.id !== areaId));
    } else {
      setMyAreasCovered([...myAreasCovered, areas.find((area) => area.id === areaId)]);
    }
  };

  const cancelChanges = () => {
    setMyAreasCovered(userProfile.coverage_areas);
    setFormChanged(false);
  };

  const saveChanges = async () => {
    setFormChanged(false);

    toast.success("Saving", {
      autoClose: 2000,
      hideProgressBar: true,
      position: "top-right",
      bodyClassName: "toast-body",
      progressClassName: "toast-progress",
      className: "toast-message",
      closeButton: false,
      icon: false,
    });

    await updateCoveredAreas(profileAuth, myAreasCovered);
    await loadProfile(profileAuth);
  };

  return (
    <div className="row g-3">
      <div className="col-md-8 order-2 order-md-1">
        <div className="accordion" id="areasAccordion">
          {regions.map((region) => {
            const regionName = region;
            let regionNameNoSpace = regionName.replace(" ", "");
            regionNameNoSpace = Math.floor(Math.random() * 1000); // Resetting to this because names is breaking the accordion
            const regionAreas = areas.filter((area) => area.region === region);

            return (
              <div key={region}>
                <div className="accordion-item">
                  <h2 className="accordion-header" id={"heading" + regionNameNoSpace}>
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={"#collapse" + regionNameNoSpace}
                      aria-expanded="false"
                      aria-controls={"collapse" + regionNameNoSpace}
                    >
                      {regionName}
                    </button>
                  </h2>

                  <div
                    id={"collapse" + regionNameNoSpace}
                    className="accordion-collapse collapse"
                    aria-labelledby={"heading" + regionNameNoSpace}
                    data-bs-parent="#areasAccordion"
                  >
                    <div className="accordion-body p-0">
                      {regionAreas.map((area) => {
                        const areaCode = area.areaCode;
                        const areaName = area.areaName;
                        const areaId = area.id;

                        const selected = checkIfCovered(areaCode);
                        return (
                          <div
                            key={area.id}
                            onClick={() => onAreaClick(areaId)}
                            className="d-flex justify-content-between align-items-center px-3 py-3 border-bottom"
                            style={{
                              cursor: "pointer",
                              backgroundColor: selected ? "#d1e7dd" : "transparent",
                              userSelect: "none",
                            }}
                          >
                            <span style={{ fontSize: "1rem" }}>
                              <span className="fw-semibold">{areaCode}</span>
                              {" — "}
                              {areaName}
                            </span>
                            {selected && <span style={{ color: "#146c43", fontSize: "1.1rem" }}>✓</span>}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="col-md-4 order-1 order-md-2">
        <div className="bg-light rounded p-3">
          <p className="fw-bold mb-2">Your current areas</p>
          {formChanged && <p className="text-danger small mb-2">You have unsaved changes</p>}
          {myAreasCovered.length === 0 ? (
            <p className="text-muted small">No areas selected</p>
          ) : (
            myAreasCovered.map((area) => (
              <div key={area.id} className="py-1 border-bottom d-flex">
                <span className="fw-semibold small" style={{ minWidth: "3rem" }}>{area.areaCode}</span>
                <span className="text-muted small">{area.areaName}</span>
              </div>
            ))
          )}
        </div>
        {formChanged && (
          <div className="d-grid gap-2 mt-3">
            <button type="submit" className="btn btn-success" onClick={saveChanges}>
              Save Changes
            </button>
            <button type="button" className="btn btn-outline-danger" onClick={cancelChanges}>
              Cancel
            </button>
          </div>
        )}
      </div>

      {formChanged && (
        <div className="col-12 order-3 mt-3">
          <div className="d-grid gap-2">
            <button type="submit" className="btn btn-success" onClick={saveChanges}>
              Save Changes
            </button>
            <button type="button" className="btn btn-outline-danger" onClick={cancelChanges}>
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

AreaCovered.propTypes = {
  userProfile: PropTypes.object.isRequired,
  regions: PropTypes.array.isRequired,
  areas: PropTypes.array.isRequired,
  profileAuth: PropTypes.object.isRequired,
  loadProfile: PropTypes.func.isRequired,
};

export default AreaCovered;
